import { render, staticRenderFns } from "./notificationEdit.vue?vue&type=template&id=31c10792&scoped=true&"
import script from "./notificationEdit.vue?vue&type=script&lang=js&"
export * from "./notificationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c10792",
  null
  
)

export default component.exports